import MixedAttachmentPicker from '@/components/Attachment/pickers/MixedAttachmentPicker'
import { checkAttachmentPickerDisableStatus } from '@/components/Attachment/utils'
import { Attachment, AttachmentType } from '@/utils/fetchers/attachment'
import { HTMLAttributes } from 'react'

export interface PostAttachmentPickerProps extends HTMLAttributes<HTMLDivElement> {
	onAdd: (attachments: Attachment[]) => void
	value: Attachment[]
}

export default function PostAttachmentPicker({
	onAdd,
	value,
	...props
}: PostAttachmentPickerProps) {
	const attachmentPickerDisableStatus = checkAttachmentPickerDisableStatus(value)
	const isPicturePickerDisabled = attachmentPickerDisableStatus[AttachmentType.PICTURE]
	const isVideoPickerDisabled = attachmentPickerDisableStatus[AttachmentType.VIDEO]
	const isLinkPickerDisabled = attachmentPickerDisableStatus[AttachmentType.LINK]

	return (
		<MixedAttachmentPicker
			isLinkPickerDisabled={isLinkPickerDisabled}
			isPicturePickerDisabled={isPicturePickerDisabled}
			isVideoPickerDisabled={isVideoPickerDisabled}
			onAdd={onAdd}
		/>
	)
}
